class GalleryResultModel {
  constructor({
    success = false,
    message = "",
    lastPage = 0,
    page = 0,
    total = 0,
    images = [],
  }) {
    this._success = success;
    this._message = message;
    this._lastPage = lastPage;
    this._page = page;
    this._total = total;
    this._images = images;
  }

  get success() {
    return this._success;
  }

  set success(value) {
    if (typeof value !== "boolean") {
      throw new Error("Success must be a boolean");
    }
    this._success = value;
  }

  get message() {
    return this._message;
  }

  set message(value) {
    if (typeof value !== "string") {
      throw new Error("Message must be a string");
    }
    this._message = value;
  }

  get lastPage() {
    return this._lastPage;
  }

  get page() {
    return this._page;
  }

  get total() {
    return this._total;
  }

  get images() {
    return this._images;
  }

  toJSON() {
    return {
      success: this._success,
      message: this._message,
      lastPage: this._lastPage,
      page: this._page,
      total: this._total,
      images: this._images,
    };
  }
}

export default GalleryResultModel;
